<div class="notification-component {{type}}" *ngIf="isActive === true">
  <Image *ngIf="type === 'success'" type="icon" image="check-circle-blue" size="small" [alt]="type"></Image>
  <ParagraphAtom [text]="text" size="large" color="dark" weight="semi-bold"></ParagraphAtom>
</div>
